import axios from 'axios';

/**
 * Interface for IP information
 */
export interface IPInfo {
  ip: string;
  country?: string;
  region?: string;
  city?: string;
  org?: string; // Internet Service Provider information
}

/**
 * Utility for getting IP-related information
 */
export class IPHelper {
  /**
   * Get user's IP address using a free public API
   * @returns Promise with the IP address and related info
   */
  public static async getIPInfo(): Promise<IPInfo> {
    try {
      // Try ipify API first
      try {
        const response = await axios.get('https://api.ipify.org?format=json', { timeout: 3000 });
        
        if (response.data && response.data.ip) {
          // Try to get location data
          try {
            const locationResponse = await axios.get(`https://ipapi.co/${response.data.ip}/json/`, { timeout: 3000 });
            
            if (locationResponse.data) {
              return {
                ip: response.data.ip,
                country: locationResponse.data.country_name,
                region: locationResponse.data.region,
                city: locationResponse.data.city,
                org: locationResponse.data.org
              };
            }
          } catch (locError) {
            console.log('Could not get detailed location info:', locError);
          }
          
          // Return just the IP if location lookup failed
          return {
            ip: response.data.ip
          };
        }
      } catch (ipifyError) {
        console.log('ipify API failed, trying alternative:', ipifyError);
      }
      
      // Fallback to ipinfo.io if ipify fails
      try {
        const backupResponse = await axios.get('https://ipinfo.io/json', { timeout: 3000 });
        
        if (backupResponse.data && backupResponse.data.ip) {
          return {
            ip: backupResponse.data.ip,
            country: backupResponse.data.country,
            region: backupResponse.data.region,
            city: backupResponse.data.city,
            org: backupResponse.data.org
          };
        }
      } catch (backupError) {
        console.log('Backup IP API failed:', backupError);
      }
      
      // Final fallback
      return {
        ip: 'Not available'
      };
    } catch (error) {
      console.error('Error getting IP address:', error);
      return {
        ip: 'Error retrieving'
      };
    }
  }
}